module.exports = __webpack_public_path__ + "img/lineup22@2x.c1020ec7.png";